export const UPDATE_MANAGER = 'manage@update-manager';
